@if (isVisible()) {
  <div class="tw-w-full">
    @for (each of displayInputs(); track each.originalIndex) {
      <div [id]="'multiSelectInput' + each.originalIndex"
           class="tw-w-full tw-flex tw-items-center tw-border-t tw-border-teal-300 tw-py-2.5 tw-px-3 tw-cursor-pointer"
           [class.tw-pointer-events-none]="isEffectivelyClosed()"
           (click)="toggleOption(each.originalIndex)">
        <div class="tw-w-3 tw-h-3 tw-rounded-sm tw-border tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-mr-3"
             [class.tw-bg-teal-600]="each.isSelected"
             [class.tw-border-teal-600]="each.isSelected"
             [class.tw-border-gray-500]="!each.isSelected && !each.isDimmed"
             [class.tw-border-gray-300]="!each.isSelected && each.isDimmed">
          @if (each.isSelected) {
            <app-arrow-icon [width]="'10px'" [height]="'10px'"></app-arrow-icon>
          }
        </div>
        <span class="tw-font-semibold tw-font-lexend"
              [class.tw-text-teal-600]="!each.isDimmed"
              [class.tw-text-gray-400]="each.isDimmed">{{ each.value }}</span>
      </div>
    }
    <!-- Submit button -->
    <div id="multiSelectSubmit"
         class="tw-w-full tw-border-t tw-border-teal-300 tw-py-1.5 tw-text-center tw-font-semibold tw-font-lexend tw-text-white tw-rounded-b-2"
         [class.tw-bg-teal-600]="hasSelection()"
         [class.tw-bg-gray-300]="!hasSelection()"
         [class.tw-pointer-events-none]="isEffectivelyClosed()"
         (click)="submit()"
         i18n="@@submit">Submit</div>
  </div>
}
